import type { FC } from "react";
import { AccordionList } from "@/design-system/Molecules";
import { Typography } from "@/design-system/Atoms";
import type { AccordionData } from "@/design-system/Molecules/AccordionList/Accordion.types";
import { cn } from "@/utils/className";

interface FAQSectionProps {
  heading?: string;
  highlight?: string;
  items: AccordionData[];
  className?: string;
  variant?: "standard" | "highlighted";
  highlightedHeadingMain?: string;
  highlightedHeadingAccent?: string;
}

const FAQSection: FC<FAQSectionProps> = ({
  heading,
  highlight = "Frequently Asked Questions",
  items,
  className = "",
  variant = "standard",
  highlightedHeadingMain,
  highlightedHeadingAccent,
}) => {
  return (
    <section
      className={cn(
        "relative block py-[75px] lg:py-[160px] overflow-hidden bg-[#f6f6f4] bg-[url('/images/bg-shape.svg')] bg-cover bg-no-repeat bg-center rounded-t-[60px]",
        className
      )}
    >
      <div className="container px-10 mx-auto text-center">
        {highlight && (
          <Typography variant="categoryText" className="mb-[1.875rem]">
            {highlight}
          </Typography>
        )}

        {variant === "highlighted" && highlightedHeadingMain && highlightedHeadingAccent ? (
          <Typography variant="sectionHeading" as="h2" className="mb-[3.125rem] text-center">
            <>
              {highlightedHeadingMain}{" "}
              <span className="text-[#8793a9]">{highlightedHeadingAccent}</span>
            </>
          </Typography>
        ) : heading ? (
          <Typography variant="sectionHeading" as="h2" className="mb-[3.125rem] text-center">
            {heading}
          </Typography>
        ) : null}

        <AccordionList data={items} />
      </div>
    </section>
  );
};

export default FAQSection;
